import {Component} from "react";
import * as React from "react";
import * as _ from "lodash";
import {BlogPost} from "./CDBBlogViewer";

interface CDBBlogCardProps
{
    blogPost: BlogPost;
}

interface CDBBlogCardState
{

}

export default class CDBBlogCard extends Component<CDBBlogCardProps,CDBBlogCardState>
{
    public async componentDidMount() {
        
    }

    public render() {

        const excerpt = document.createElement("div");
        const excerptText = _.truncate(this.props.blogPost.excerpt.rendered,{
            "length": 200,
            "omission": "...",
            "separator": " "
        });
        
        excerpt.innerHTML = excerptText;
        
        const title = document.createElement("div");
        title.innerHTML = this.props.blogPost.title.rendered;

        const link = this.props.blogPost.link.replace("tonyishere.co.uk","clouddesignbox.co.uk")
        
        return (
            <a href={link} target="_blank" className={"cdb-blog-card"}>
                <img src={this.props.blogPost.jetpack_featured_media_url}/>
                <div className={"cdb-blog-card__content"}>
                    <div className={"cdb-blog-card__title"}>{title.textContent}</div>
                    <div className={"cdb-blog-card__excerpt"}>{excerpt.textContent}</div>
                </div>
            </a>
        );
    }
}